import { Button } from 'antd'
import './style.css'
import MBodyPoints from '../MBodyPoints';
import { useEffect, useState } from 'react';
import { EvaluationData } from '@pages/Home/interface';
import { useTranslation } from 'react-i18next';
import { useTypedDispatch, useTypedSelector } from '@stores/index';
import { getEvaluationData } from '@stores/myLibrary/myLibrary';
import { TOnBoardSymptomsProps } from '@stores/interfaces';

export default function PainAssessment(props: TOnBoardSymptomsProps) {
  const { setActiveStep, setProgressPercent , setNavigatorDirection} = props
  const [isLoading, setIsLoading] = useState(true);
  const [savedEvaluationData, setSavedEvaluationData] = useState<EvaluationData>();
  const { t } = useTranslation()
  const dispatch = useTypedDispatch();
  const user = useTypedSelector((state) => state.user);

  useEffect(() => {
    fetchSavedData();
  }, [user])

  const fetchSavedData = async () => {
    const id = user.id;
    const payload = {
      userId: id,
      page: 1,
      limit: 1,
    };
    const data = await dispatch(getEvaluationData(payload));
    const apiData = data.payload;
    if (apiData.data.length > 0) {
      setSavedEvaluationData(apiData.data[0]);
    }
  }

  const handleNextClick = () => {
    setNavigatorDirection('forward')
    setActiveStep(4);
    setProgressPercent(40);
  }

  const nextButtonStyle = {
    height: '43px',
    background : 'var(--onboard-button-color)',
    color : '#fff',
    width : '290px',
    border: 'none',
  }

  return (
    <>
      <div className='medical-container'>
        <h1 className='pain-assessment-title-label'>
          {t('Patient.data.virtualEvaluation.painAssesment.title')}
        </h1>
        <h3 className='pain-assessment-sub-title-label'> {t('Patient.data.virtualEvaluation.painAssesment.description')}</h3>
      </div>
      <div className="pain-assessment select-none" style={{ margin: '0px auto', width: '80%' }}>
        <MBodyPoints
          assessmentData={savedEvaluationData?.painAssessments || []}
          savedEvaluationData={savedEvaluationData}
          setSavedEvaluationData={setSavedEvaluationData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </div>
      <div className='medical-container'>
        <Button className="back-button-css" onClick={() => { setNavigatorDirection('backward'); setActiveStep(2) }} 
         size="large" block style={nextButtonStyle}>
          {t('Patient.data.onboard.back')}
        </Button>&nbsp;
        <Button className="next-button-css" size="large" block style={nextButtonStyle} onClick={handleNextClick}>
          {t('Patient.data.onboard.next')}
        </Button>
      </div>
    </>
  )
}
